import dynamic from 'next/dynamic';

import { CashAndPointsProps } from './CashAndPoints.types';

export const CashAndPoints = dynamic<CashAndPointsProps>(() =>
  import('./CashAndPoints').then(module => module.CashAndPoints)
);
